import styled from 'styled-components';

// ===== Styled Components ===== //

export const AgreementContainer = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const AgreementText = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #000;
  line-height: 15px;
`; 